export default {
  ENTERPRISE_PRO_LABOR_FORM_SUCCESS: "Your form has successfully been submitted",
  ENTERPRISE_PRO_LABOR_FORM_FAIL: "There was an error submitting your Build Partner Application",
};
